import { render } from "./link-company-mcl.vue?vue&type=template&id=3810e2b0"
import script from "./link-company-mcl.vue?vue&type=script&lang=js"
export * from "./link-company-mcl.vue?vue&type=script&lang=js"

import "./link-company-mcl.vue?vue&type=style&index=0&id=3810e2b0&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__